import image0 from '../assets/players/victory/Aegis.webp';
import image1 from '../assets/players/victory/Beep.webp';
import image2 from '../assets/players/victory/Ben.webp';
import image3 from '../assets/players/victory/Bits.webp';
import image4 from '../assets/players/victory/Boo.webp';
import image5 from '../assets/players/victory/Buck.webp';
import image6 from '../assets/players/victory/Cactus.webp';
import image7 from '../assets/players/victory/Clank.webp';
import image8 from '../assets/players/victory/Don.webp';
import image9 from '../assets/players/victory/Dust.webp';
import image10 from '../assets/players/victory/Ember.webp';
import image11 from '../assets/players/victory/Ethan.webp';
import image12 from '../assets/players/victory/Fan.webp';
import image13 from '../assets/players/victory/Fang.webp';
import image14 from '../assets/players/victory/Flap.webp';
import image15 from '../assets/players/victory/Groan.webp';
import image16 from '../assets/players/victory/Howl.webp';
import image17 from '../assets/players/victory/Jade.webp';
import image18 from '../assets/players/victory/Kong.webp';
import image19 from '../assets/players/victory/Lotus.webp';
import image20 from '../assets/players/victory/Mimic.webp';
import image21 from '../assets/players/victory/Nib.webp';
import image22 from '../assets/players/victory/Nova.webp';
import image23 from '../assets/players/victory/Pearl.webp';
import image24 from '../assets/players/victory/Pew.webp';
import image25 from '../assets/players/victory/Pip.webp';
import image26 from '../assets/players/victory/Plop.webp';
import image27 from '../assets/players/victory/Pot.webp';
import image28 from '../assets/players/victory/Puff.webp';
import image29 from '../assets/players/victory/Rattle.webp';
import image30 from '../assets/players/victory/Rune.webp';
import image31 from '../assets/players/victory/Sage.webp';
import image32 from '../assets/players/victory/Snap.webp';
import image33 from '../assets/players/victory/Thorn.webp';
import image34 from '../assets/players/victory/Tusk.webp';
import image35 from '../assets/players/victory/Twig.webp';
import image36 from '../assets/players/victory/Viking.webp';
import image37 from '../assets/players/victory/Void.webp';
import image38 from '../assets/players/victory/Wisp.webp';
import image39 from '../assets/players/victory/Zzz.webp';
const tournamentVictoryImages = {
  'Aegis': image0,
  'Beep': image1,
  'Ben': image2,
  'Bits': image3,
  'Boo': image4,
  'Buck': image5,
  'Cactus': image6,
  'Clank': image7,
  'Don': image8,
  'Dust': image9,
  'Ember': image10,
  'Ethan': image11,
  'Fan': image12,
  'Fang': image13,
  'Flap': image14,
  'Groan': image15,
  'Howl': image16,
  'Jade': image17,
  'Kong': image18,
  'Lotus': image19,
  'Mimic': image20,
  'Nib': image21,
  'Nova': image22,
  'Pearl': image23,
  'Pew': image24,
  'Pip': image25,
  'Plop': image26,
  'Pot': image27,
  'Puff': image28,
  'Rattle': image29,
  'Rune': image30,
  'Sage': image31,
  'Snap': image32,
  'Thorn': image33,
  'Tusk': image34,
  'Twig': image35,
  'Viking': image36,
  'Void': image37,
  'Wisp': image38,
  'Zzz': image39,
};

export default tournamentVictoryImages;
